import { use } from 'react';
import { ModalStackContext } from '@/contexts/modal-stack-context-definition';

export function useModalStack() {
  const context = use(ModalStackContext);
  if (!context) {
    throw new Error('useModalStack must be used within a ModalStackProvider');
  }
  return context;
}
